"use strict";

import jQuery from 'jquery';

/**
 * @enum
 */
gc.gis.ui.GCSidebarEvent = {
	/**
	 * Wenn sich der Contentbereich ändert.
	 */
	CONTENT_CHANGED: 'change:content'
};

/**
 * @classdesc
 * Sidebar.
 *
 * <h4>Aufbau des Layouts:</h4>
 * <pre>
 * +-----------------------------------------------------------------------+
 * | .gc-gis-sidebar                                      [display: block] |
 * |                                                  [position: absolute] |
 * | +-------------------------------------------------------------------+ |
 * | | .gc-sidebar-header                           [position: absolute] | |
 * | +-------------------------------------------------------------------+ |
 * | +---------------------------------------+ +-------------------------+ |
 * | | .gc-sidebar-scroll-container          | | .gc-sidebar-content     | |
 * | |                                       | |                         | |
 * | |                  [position: absolute] | |    [position: absolute] | |
 * | |                                       | |                         | |
 * | | +-----------------------------------+ | |                         | |
 * | | | .gc-sidebar-scroll-up             | | |                         | |
 * | | |              [position: absolute] | | |                         | |
 * | | +-----------------------------------+ | |                         | |
 * | | +-----------------------------------------------------------------------+---+
 * | | | .gc-sidebar-scroll-content          . .    [position: absolute] . .   | ^ |
 * | | |                                     . .        [overflow: auto] . .   +---+
 * | | | Damit die Scrollbar verschwindet,   . .                         . .   |   |
 * | | | ist das Element 200% breit, sowie   . .                         . .   |   |
 * | | | das Kindelement ~50% breit, womit   . .                         . .   |   |
 * | | | sich die Breite des Launchermenüs   . .                         . .   |   |
 * | | | wieder ausgleicht.                  . .                         . .   |   |
 * | | |                                     . .                         . .   |   |
 * | | | +---------------------------------+ . .                         . .   |   |
 * | | | |                                 | . .                         . .   |   |
 * | | | | .gc-sidebar-launchermenu        | . .                         . .   |   |
 * | | | |                                 | . .                         . .   +---+
 * | | | +---------------------------------+ . .                         . .   | v |
 * | | +-----------------------------------------------------------------------+---+
 * | | +-----------------------------------+ | |                         | |
 * | | | .gc-sidebar-scroll-down           | | |                         | |
 * | | |              [position: absolute] | | |                         | |
 * | | +-----------------------------------+ | |                         | |
 * | +---------------------------------------+ +-------------------------+ |
 * +-----------------------------------------------------------------------+
 * </pre>
 *
 * @class
 * @extends gc.gis.GCObservable
 * @memberof gc.gis.ui
 * @author Anton Popov <a.popov@brain-scc.de>
 *
 * @param {Object} options Aufrufoptionen
 */
gc.gis.ui.GCSidebar = function( options )
{
	/**
	 * @protected
	 * @type {gc.gis.ui.GCSidebarContent|null}
	 */
	this._content = null;

	/**
	 * @protected
	 * @type {jQuery}
	 */
	this._element = undefined;

	// states
	/**
	 * @protected
	 * @type{boolean}
	 */
	this._closed = false;
	/**
	 * @protected
	 * @type {boolean}
	 */
	this._collapsed = options.startCollapsed === true;
	/**
	 * @protected
	 * @type {boolean}
	 */
	this._shaded = false;

	this._initUI();
	this._initEvents();

	gc.gis.GCObservable.call( this );
};
gc.gis.ui.GCSidebar.prototype = Object.create( gc.gis.GCObservable.prototype );

/**
 * @protected
 */
gc.gis.ui.GCSidebar.prototype._initUI = function()
{
	var self = this;

	// Actionbar
	/**
	 * @protected
	 * @type {jQuery}
     */
	this._btn_back = jQuery('<a>', {
		href: '#',
		title: 'Zurück',
		html: '<span class="gc-icon glyphicon glyphicon-arrow-left"></span><span>Zurück</span>',
		'class': 'gc-sidebar-header-button gc-sidebar-header-button-left',
		click: function( evt ) {
			evt.preventDefault();
			jQuery(this).blur();
			self.historyBack();
		}
	});
	gc.gis.iface.ui.tooltip(this._btn_back, {
		placement: 'auto right'
	});

	/**
	 * @protected
	 * @type {jQuery}
	 */
	this._btn_collapse = jQuery('<a>', {
		href: '#',
		html: '<span class="gc-icon glyphicon glyphicon-chevron-left"></span><span>Ein-/Ausklappen</span>',
		'class': 'gc-sidebar-header-button gc-sidebar-header-button-left',
		click: function( evt ) {
			evt.preventDefault();
			jQuery(this).blur();
			self.toggleExpanded();
		}
	});
	gc.gis.iface.ui.tooltip(this._btn_collapse, {
		placement: 'auto right',
		title: function() {
			return self._collapsed ? 'Menü ausklappen' : 'Menü einklappen';
		}
	});

	/**
	 * @protected
	 * @type {jQuery}
	 */
	this._btn_close = jQuery('<a>', {
		href: '#',
		title: 'Schließen',
		html: '<span class="gc-icon glyphicon glyphicon-remove"></span><span>Schließen</span>',
		'class': 'gc-sidebar-header-button gc-sidebar-header-button-right',		// FIXME
		click: function( evt ) {
			evt.preventDefault();
			jQuery(this).blur();
			self.close();
		}
	});
	gc.gis.iface.ui.tooltip(this._btn_close, {
		placement: function() {
			if( gc.gis.iface.ui.matchMedia('xs') )
			{
				return 'auto left';
			}
			return 'auto right';
		}
	});

	/**
	 * @protected
	 * @type {jQuery}
	 */
	this._element_label = jQuery('<span>', {
		'class': 'gc-sidebar-label',
		text: 'Menü'
	});
	/**
	 * @protected
	 * @type {jQuery}
	 */
	this._element_label_wrapper = jQuery('<h1>', {
		'class': 'gc-sidebar-label-wrapper',
		html: this._element_label
	});

	/**
	 * @protected
	 * @type {jQuery}
	 */
	this._element_actionbar = jQuery('<div>', {
		'class': 'gc-sidebar-header'
	});
	this._element_actionbar
		.append( this._btn_collapse )
		.append( this._btn_back )
		.append( this._element_label_wrapper )
		.append( this._btn_close );

	// Launcher-Menü
	/**
	 * @protected
	 * @type {jQuery}
	 */
	this._btn_scrollup = jQuery('<button>', {
		//href: '#',
		title: 'Hochscrollen',
		html: '<span>Hochscrollen</span>',
		click: function( evt ) {
			evt.preventDefault();
			jQuery(this).blur();
			self._scrollLauncherUp( evt );
		}
	});
	this._btn_scrollup.prepend( jQuery('<span>', {
		'class': 'gc-icon glyphicon glyphicon-chevron-up'
	}));
	gc.gis.iface.ui.tooltip(this._btn_scrollup, {
		placement: function() {
			if(gc.gis.iface.getElement().hasClass('gc-sidebar-panel-active')
				|| gc.gis.iface.getElement().hasClass('gc-sidebar-collapsed'))
			{
				return 'auto right';
			}
			return 'auto bottom';
		}
	});

	/**
	 * @protected
	 * @type {jQuery}
	 */
	this._btn_scrolldown = jQuery('<button>', {
		//href: '#',
		title: 'Runterscrollen',
		html: '<span>Runterscrollen</span>',
		click: function( evt ) {
			evt.preventDefault();
			jQuery(this).blur();
			self._scrollLauncherDown( evt );
		}
	});
	this._btn_scrolldown.prepend( jQuery('<span>', {
		'class': 'gc-icon glyphicon glyphicon-chevron-down'
	}));
	gc.gis.iface.ui.tooltip(this._btn_scrolldown, {
		placement: function() {
			if( gc.gis.iface.getElement().hasClass('gc-sidebar-panel-active') ||
				gc.gis.iface.getElement().hasClass('gc-sidebar-collapsed') )
			{
				return 'auto right';
			}
			return 'auto top';
		}
	});

	/**
	 * @protected
	 * @type {jQuery}
	 */
	this._element_scrollup = jQuery('<div>', {
		'class': 'gc-sidebar-scroll-up',
		html: this._btn_scrollup
	});
	/**
	 * @protected
	 * @type {jQuery}
	 */
	this._element_scrolldown = jQuery('<div>', {
		'class': 'gc-sidebar-scroll-down',
		html: this._btn_scrolldown
	});

	/**
	 * @protected
	 * @type {jQuery}
	 */
	this._element_launchermenu = jQuery('<ul>', {
		'class': 'gc-sidebar-launchermenu'
	});
	/**
	 * @protected
	 * @type {jQuery}
	 */
	this._element_launchermenu_scroll_content = jQuery('<div>', {
		'class': 'gc-sidebar-scroll-content',
		html: this._element_launchermenu
	});
	/**
	 * @protected
	 * @type {jQuery}
	 */
	this._element_launchermenu_wrapper = jQuery('<div>', {
		'class': 'gc-sidebar-scroll-container'
	});
	this._element_launchermenu_wrapper
		.append( this._element_scrollup )
		.append( this._element_launchermenu_scroll_content )
		.append( this._element_scrolldown );

	// Content
	/**
	 * @protected
	 * @type {jQuery}
	 */
	this._element_content = jQuery('<div>', {
		'class': 'gc-sidebar-content'
	});

	// Wrapper
	/**
	 * @protected
	 * @type {jQuery}
	 */
	this._element = jQuery('<div>', {
		'class': 'gc-gis-sidebar'
	});
	this._element
		.append( this._element_actionbar )
		.append( this._element_launchermenu_wrapper )
		.append( this._element_content );

	// Outside-Access-Button
	/**
	 * @protected
	 * @type {jQuery}
	 */
	this._btn_access = jQuery('<a>', {
		href: '#',
		html: '<span>Menü öffnen/schließen</span>',
		'class': 'gc-icon glyphicon glyphicon-menu-hamburger',
		click: function( evt ) {
			evt.preventDefault();
			jQuery(this).blur();
			self.toggleOpened();
		}
	});
	gc.gis.iface.ui.tooltip(this._btn_access, {
		placement: 'auto right',
		title: function() {
			return self._closed ? 'Menü öffnen' :'Menü schließen';
		}
	});

	var element_container_access = jQuery('<div>', {
		'class': 'gc-sidebar-access-button gc-sidebar-hidden-expanded',
		html: this._btn_access
	});

	gc.gis.iface.ui.attach( element_container_access, {
		target: gc.gis.iface.ui.main
	});

	// Update header actions
	this._updateHeaderActions();
	this._updateClosedStatus();
	this._updateExpandedStatus();
};

/**
 * @protected
 */
gc.gis.ui.GCSidebar.prototype._initEvents = function()
{
	var self = this;

	this._element_launchermenu_scroll_content.scroll( function( evt ) {
		self._updateLauncherScroll( evt );
	});
	this._element_launchermenu_scroll_content.resize( function( evt ) {
		self._updateLauncherScroll( evt );
	});
};

/**
 *
 * @param {Object<string,*>} options
 * @param {string} options.icon Icon-Klasse(n)
 * @param {string} options.label Label
 * @param {gc.gis.ui.GCSidebarContent} options.content Anzuzeigender Content
 * @return {int} Index, an dem der Launcher eingefügt wurde
 * @public
 */
gc.gis.ui.GCSidebar.prototype.addLauncher = function( options )
{
	var self = this;
    options.icon = options.icon || 'glyphicon glyphicon-chevron-right';

	var element_launcher = jQuery('<a>', {
		'class': 'gc-launcher'+ (options.className ? ' '+ options.className : ''),
		href: '#',
		click: function (evt) {
			evt.preventDefault();
			self.setContent( options.content );
			jQuery(this).blur();
		}
	});
	if( options.icon )
	{
		element_launcher.append( jQuery('<span>', {
			'class': 'gc-icon '+ options.icon
		}) );
	}
	element_launcher.append( jQuery('<span>', {text: options.label}) );
	gc.gis.iface.ui.tooltip(element_launcher, {
		placement: 'auto right',
		title: function() {
			if( gc.gis.iface.getElement().hasClass('gc-sidebar-panel-active') ||
				gc.gis.iface.getElement().hasClass('gc-sidebar-collapsed') )
			{
				return options.label;
			}
			return '';
		}
	});

	options.element = element_launcher;
	options.content._launcher = element_launcher;
	this._element_launchermenu.append( jQuery('<li>', {
		html: element_launcher
	}) );

    return this._element_launchermenu.children().length - 1;
};

/**
 * Setzt die Sichtbarkeit des Launcher-Elements am entsprechenden Index.
 * @param {int} index
 * @param {boolean} visible
 * @public
 */
gc.gis.ui.GCSidebar.prototype.setLauncherVisibility = function(index, visible)
{
	if (index >= 0 && index < this._element_launchermenu.children().length)
	{
		var li = this._element_launchermenu.children()[index];
		if (visible) {
            jQuery(li).show();
		}
		else {
            jQuery(li).hide();
		}
	}
};

/**
 * @public
 * @returns {gc.gis.ui.GCSidebarContent|null}
 */
gc.gis.ui.GCSidebar.prototype.getContent = function()
{
	return this._content;
};

/**
 * @public
 * @param {gc.gis.ui.GCSidebarContent} content
 */
gc.gis.ui.GCSidebar.prototype.setContent = function( content )
{
	var self = this;

	try {
		var old = this._content;

		if (old === content) {
			content = null;
		}
		this._content = content;

		this._element_content.hide('slide', {
			direction: (content ? 'left' : 'right'),
			complete: function () {
				self._element_content.children().detach();
				if (content) {
					self._element_label.html(content.getLabel());
					self._element_content.append(content.getElement());
					if (!self._closed || !self._collapsed) {
						self._element_content.show('slide', {direction: 'right'}, 200);
						self.open();
						self.expand();
					}
					else {
						self._element_content.show();
					}
				}
				else {
					self._element_label.html('Menü');
				}
			}
		}, 200);
		this._updateHeaderActions();
		this._updateActiveLauncher(content);

		this._fireEvent(gc.gis.ui.GCSidebarEvent.CONTENT_CHANGED, {
			oldValue: old,
			newValue: this._content
		});
	}
	catch( err )
	{
		gc.gis.iface.log.error( this, err );
	}
};

/**
 * @protected
 */
gc.gis.ui.GCSidebar.prototype._updateHeaderActions = function()
{
	if( this._content === null )
	{
		this._btn_back.hide();
		this._btn_collapse.show();
	}
	else {
		this._btn_back.show();
		this._btn_collapse.hide();
	}
};

/**
 * @protected
 * @param {gc.gis.ui.GCSidebarContent} content
 */
gc.gis.ui.GCSidebar.prototype._updateActiveLauncher = function( content )
{
	gc.gis.iface.getElement().removeClass('gc-sidebar-panel-active');
	this._element_launchermenu.find('.gc-launcher').removeClass('gc-active');
	if( content && content.getLauncher )
	{
		gc.gis.iface.getElement().addClass('gc-sidebar-panel-active');
		content.getLauncher().addClass('gc-active');
	}
};

/**
 * @protected
 * @param evt
 */
gc.gis.ui.GCSidebar.prototype._scrollLauncherUp = function( evt )
{
	this._element_launchermenu_scroll_content.stop().animate({
		scrollTop: this._element_launchermenu_scroll_content[0].scrollTop
		- this._element_launchermenu_scroll_content[0].offsetHeight/2
	}, 'fast');
};

/**
 * @protected
 * @param evt
 */
gc.gis.ui.GCSidebar.prototype._scrollLauncherDown = function( evt )
{
	this._element_launchermenu_scroll_content.stop().animate({
		scrollTop: this._element_launchermenu_scroll_content[0].scrollTop
		+ this._element_launchermenu_scroll_content[0].offsetHeight/2
	}, 'fast');
};

/**
 * @public
 * @param evt
 */
gc.gis.ui.GCSidebar.prototype._updateLauncherScroll = function( evt )
{
	var content = this._element_launchermenu_scroll_content[0];
	var t = content.scrollTop;
	var oh = content.offsetHeight;
	var sh = content.scrollHeight;

	if( t === 0 )
	{
		this._btn_scrollup.attr('disabled','disabled');
	}
	else {
		this._btn_scrollup.removeAttr('disabled');
	}

	if( sh-oh === t )
	{
		this._btn_scrolldown.attr('disabled','disabled');
	}
	else {
		this._btn_scrolldown.removeAttr('disabled');
	}
};

/**
 * @public
 */
gc.gis.ui.GCSidebar.prototype.shade = function()
{
	this._shaded = true;
	this._element.hide('slide');
	gc.gis.iface.getElement().removeClass('gc-sidebar-unshaded').addClass('gc-sidebar-shaded');
	this._fireEvent( gc.gis.ui.GCSidebarEvent.SHADE_CHANGED, {
		state: this._shaded
	});
};

/**
 * @public
 */
gc.gis.ui.GCSidebar.prototype.unshade = function()
{
	this._shaded = false;
	this._element.show('slide');
	gc.gis.iface.getElement().removeClass('gc-sidebar-shaded').addClass('gc-sidebar-unshaded');
	this._fireEvent( gc.gis.ui.GCSidebarEvent.SHADE_CHANGED, {
		state: this._shaded
	});
};

/**
 * @public
 */
gc.gis.ui.GCSidebar.prototype.open = function()
{
	this._closed = false;
	this._element.show('slide');
	this._updateClosedStatus();
	this._fireEvent( gc.gis.ui.GCSidebarEvent.OPEN_CHANGED, {
		state: !this._closed
	});
};

/**
 * @public
 */
gc.gis.ui.GCSidebar.prototype.close = function()
{
	this._closed = true;
	this._element.hide('slide');
	this._updateClosedStatus();
	this._fireEvent( gc.gis.ui.GCSidebarEvent.OPEN_CHANGED, {
		state: !this._closed
	});
};

/**
 * @protected
 */
gc.gis.ui.GCSidebar.prototype._updateClosedStatus = function()
{
	if( this._closed )
	{
		gc.gis.iface.getElement().removeClass('gc-sidebar-opened').addClass('gc-sidebar-closed');
	}
	else
	{
		gc.gis.iface.getElement().removeClass('gc-sidebar-closed').addClass('gc-sidebar-opened');
	}
};

/**
 * @public
 */
gc.gis.ui.GCSidebar.prototype.expand = function()
{
	this._collapsed = false;
	//this._element_content.show('slide');
	this._updateExpandedStatus();
	this._fireEvent( gc.gis.ui.GCSidebarEvent.EXPAND_CHANGED, {
		state: !this._collapsed
	});
};

/**
 * @public
 */
gc.gis.ui.GCSidebar.prototype.collapse = function()
{
	this._collapsed = true;
	//this._element_content.hide('slide');
	this._updateExpandedStatus();
	this._fireEvent( gc.gis.ui.GCSidebarEvent.EXPAND_CHANGED, {
		state: !this._collapsed
	});
};

/**
 * @protected
 */
gc.gis.ui.GCSidebar.prototype._updateExpandedStatus = function()
{
	if( this._collapsed )
	{
		this._btn_collapse.children('.gc-icon').removeClass('glyphicon-chevron-left').addClass('glyphicon-chevron-right');
		gc.gis.iface.getElement().removeClass('gc-sidebar-expanded').addClass('gc-sidebar-collapsed');
	}
	else
	{
		this._btn_collapse.children('.gc-icon').removeClass('glyphicon-chevron-right').addClass('glyphicon-chevron-left');
		gc.gis.iface.getElement().removeClass('gc-sidebar-collapsed').addClass('gc-sidebar-expanded');
	}
};

/**
 * @public
 */
gc.gis.ui.GCSidebar.prototype.toggleExpanded = function()
{
	if( this._collapsed === true )
	{
		this.expand();
	}
	else
	{
		this.collapse();
	}
};

/**
 * @public
 */
gc.gis.ui.GCSidebar.prototype.toggleOpened = function()
{
	if( this._closed === true )
	{
		this.open();
	}
	else
	{
		this.close();
	}
};

/**
 * @public
 */
gc.gis.ui.GCSidebar.prototype.historyBack = function()
{
	this.setContent( this._content ? this._content.getParent() : null );
};

/**
 * @public
 * @returns {jQuery}
 */
gc.gis.ui.GCSidebar.prototype.getElement = function()
{
	return this._element;
};

/**
 * @public
 * @param {Object<string,*>} options
 * @param {string} options.label
 * @param {function} options.click
 * @returns {jQuery}
 */
gc.gis.ui.GCSidebar.prototype.createSubmenuItem = function( options )
{
	var self = this;

	var label = options.label;
	if (typeof label === 'string')
	{
		label = '<span>'+ label +'</span>';
	}
	if (options.icon)
	{
        label = '<span class="gc-icon ' + options.icon + '"></span>' + label;
	}

	var element = jQuery('<a>', {
		'class': 'gc-sidebar-submenu-item' + (options.icon ? '' : ' no-icon'),
		href: '#',
		html: label,
		click: function( evt ) {
			evt.preventDefault();
			options.click.call( self, evt );
		}
	});

	return element;
};
